import ic_facebook from "../../assets/icons/ic_facebook_white.svg";
import ic_youtube from "../../assets/icons/ic_youtube_white.svg";
import ic_twitter from "../../assets/icons/ic_twitter_white.svg";
import ic_instagram from "../../assets/icons/ic_instagram_white.svg";
import { useAuthContext } from "../../context/AuthContext";
import { BlackTextLinearGradient } from "../../utils/Utils";

function Footer() {
  const auth = useAuthContext();

  return (
    <div
      className={`flex gap-5 justify-center items-center flex-col md:flex-row w-full px-10 md:px-16 xl:px-32 py-8 ${
        auth.state.user
          ? "bg-primary-white dark:bg-primary-darkBlue"
          : "bg-[#25272D]"
      } text-primary-lightBlue`}
    >
      <div className="flex-1 flex flex-col space-y-3 w-full">
        <div
          className={`md:flex grid grid-cols-2 gap-5 md:flex-row w-full  text-sm ${
            auth.state.user ? BlackTextLinearGradient : "text-white"
          }`}
        >
          {/* <p className="flex">
            <a href="/about-us">About Us</a>
          </p> */}
          <p className="flex">
            <a href="/science-behind-every-move">Science Room</a>
          </p>
          <p className="flex">
            <a href="/subscription">Pricing</a>
          </p>
          <p className="flex">
            <a href="/terms">Terms & Conditions</a>
          </p>

          <p className="flex">
            <a href="/faq">FAQs</a>
          </p>
          <p className="flex">
            <a href="/testimonials">Testimonials</a>
          </p>
        </div>
        <p
          className={`hidden md:flex text-sm text-white text-opacity-50 ${
            auth.state.user ? BlackTextLinearGradient : "text-white"
          }`}
        >
          &#169; 2023 upUgo &amp; Surgg Pvt. Ltd. All rights reserved <br />
          F NO L 1202 Mantri Espana Apartments <br />
          Kariyammana Agraha Bellandur Bangalore <br />
          560103 Karnataka India
        </p>
      </div>
      <div className="flex flex-row space-x-8 md:space-x-5 md:max-w-max w-full">
        <a
          href="https://www.facebook.com/Getactyv-102589489264568"
          className="dark:bg-white bg-primary-midBlack dark:bg-opacity-5 bg-opacity-50 p-3 rounded"
        >
          <img src={ic_facebook} />
        </a>
        <a
          href="https://twitter.com/getactyv"
          className="dark:bg-white bg-primary-midBlack dark:bg-opacity-5 bg-opacity-50 p-3 rounded"
        >
          <img src={ic_twitter} />
        </a>
        <a
          href="https://www.instagram.com/getactyv/"
          className="dark:bg-white bg-primary-midBlack dark:bg-opacity-5 bg-opacity-50 p-3 rounded"
        >
          <img src={ic_instagram} />
        </a>
        <a
          href="https://www.youtube.com/@getactyv"
          className="dark:bg-white bg-primary-midBlack dark:bg-opacity-5 bg-opacity-50 p-3 rounded"
        >
          <img src={ic_youtube} />
        </a>
      </div>
      <p
        className={`flex md:hidden text-sm text-white text-opacity-50 ${
          auth.state.user ? BlackTextLinearGradient : "text-white"
        }`}
      >
        &#169; 2022 upUgo &amp; Surgg Pvt. Ltd. All rights reserved
      </p>
    </div>
  );
}

export default Footer;
